import * as React from 'react';
import { Typography, Popover, IconButton, } from '@one-thd/sui-atomic-components';
import { InfoFilled } from '@one-thd/sui-icons';
export var InfoPopover = function (_a) {
    var iconsize = _a.iconsize, title = _a.title, message = _a.message, _b = _a.placement, placement = _b === void 0 ? 'bottom' : _b;
    var _c = React.useState(null), anchorEl = _c[0], setAnchorEl = _c[1];
    var handleClick = function (event) {
        setAnchorEl(event.currentTarget);
    };
    var handleClose = function () {
        setAnchorEl(null);
    };
    var open = Boolean(anchorEl);
    var id = open ? "".concat(placement, "-popover") : undefined;
    var Icon = function () { return (React.createElement(InfoFilled, { size: iconsize, color: "info", "aria-label": "infoIcon" })); };
    return (React.createElement("div", { className: "sui-outline-0 sui-inline sui-pt-4" },
        React.createElement(IconButton, { "aria-describedby": id, onClick: handleClick, icon: Icon, size: iconsize, "aria-label": "infoButton" }),
        React.createElement(Popover, { id: id, open: open, anchorEl: anchorEl, onClose: handleClose, placement: placement, title: title },
            React.createElement(Typography, { variant: "body-base" }, message))));
};
